import { render } from "./Offers.vue?vue&type=template&id=691156f2&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"

import "./Offers.vue?vue&type=style&index=0&id=691156f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-691156f2"

export default script